import { createSlice } from "@reduxjs/toolkit";
import { fetchInventoryItemRequestStockAllocationLog } from "./thunk";

interface initialStateType {
  itemRequestListStockAllocationLog: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: initialStateType = {
  itemRequestListStockAllocationLog: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const InventoryItemRequestSlice = createSlice({
  name: "InventoryItemRequest",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInventoryItemRequestStockAllocationLog.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInventoryItemRequestStockAllocationLog.fulfilled, (state, action) => {
        state.loading = false;
        state.itemRequestListStockAllocationLog = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchInventoryItemRequestStockAllocationLog.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch Stock Allocation Log";
      });
  },
});

export default InventoryItemRequestSlice.reducer;
